import React from 'react'
import "../Assets/styles/anon.css"
import Accordion from 'react-bootstrap/Accordion';
import faq1 from "../Assets/images/faq_faq_png.png";
import { FaQuestion } from "react-icons/fa6";

const Faq = () => {
  return (
    <>
      <div className="anon">
        <div className='anon-bg'>
        <h1><FaQuestion/></h1>
        <h4><a href='/home'>Home </a><span className='dot'></span> Faq</h4>
        </div>
      </div>
      <div className='container-lg faq'>
        <h1 className='uty'>Frequently <span>Asked</span> Questions</h1>
        <p className='uty'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incidiunt labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p>
        <div className='row gba'>
          <div className='col-lg-6'>
          <Accordion defaultActiveKey="0" flush>
          <Accordion.Item eventKey="0">
          <Accordion.Header>What access do I have on the free plan?</Accordion.Header>
          <Accordion.Body>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
          <Accordion.Header>What access do I have on a free trial?</Accordion.Header>
          <Accordion.Body>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
          <Accordion.Header>Does the price go up as my team gets larger?</Accordion.Header>
          <Accordion.Body>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
          <Accordion.Header>How do I cancel my subscription?</Accordion.Header>
          <Accordion.Body>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="4">
          <Accordion.Header>Can I pay via invoice?</Accordion.Header>
          <Accordion.Body>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </Accordion.Body>
          </Accordion.Item>
          </Accordion>
          </div>
          <div className='col-lg-6 faq1'>
            <img src={faq1} alt='ser'/>
          </div>
        </div>
      </div>
    </>
  )
}

export default Faq